import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import messages from './i18n.json'
import './styles.scss'

// Font Awesome imports
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
  faCheckCircle, 
  faFilePdf, 
  faGlobeAmericas, 
  faQuestionCircle, 
  faChevronLeft, 
  faCreditCard, 
  faMinus,
  faPlus,
  faRotateLeft
} from '@fortawesome/free-solid-svg-icons'

// Add icons to the library
library.add(
  faCheckCircle, 
  faFilePdf, 
  faGlobeAmericas, 
  faQuestionCircle, 
  faChevronLeft, 
  faCreditCard, 
  faMinus, 
  faPlus,
  faRotateLeft
)

// Create i18n instance
const i18n = createI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
  legacy: false, // you must set `false`, to use Composition API
  globalInjection: true, // set to true to inject $t globally
  silentTranslationWarn: true, // suppress warnings for missing keys
  missingWarn: false,
  fallbackWarn: false,
  silentFallbackWarn: true,
  warnHtmlMessage: false, // suppress HTML in message warnings
  warnHtmlInMessage: 'off', // suppress HTML in message warnings
  escapeParameter: false, // allow HTML parameters
  flatJson: true, // enable flat JSON mode for dot-notation keys
  compileError: false, // suppress compilation errors
  messageCompiler: undefined // use default compiler without strict checks
})

const app = createApp(App)

app.use(store)
app.use(router)
app.use(i18n)
app.component('font-awesome-icon', FontAwesomeIcon)

// Suppress Vue warnings for maska directive resolution
if (process.env.NODE_ENV === 'development') {
  app.config.warnHandler = (msg) => {
    if (!msg.includes('maska')) {
      console.warn(msg)
    }
  }
}

app.mount('#app')
